<template>
  <div class="app-footer" :class="{ 'app-footer--mobile': deviceType === 'mobile' }">
    <!-- Sitename -->
    <div class="app-footer__brand">{{ siteNameText }}</div>

    <!-- Links -->
    <div class="app-footer__links">
      <a :href="getFooterLink('/about-us')" class="app-footer__link">About Us</a>
      <a :href="getFooterLink('/terms-of-service')" class="app-footer__link">Terms of Services</a>
      <a :href="getFooterLink('/privacy-policy')" class="app-footer__link">Privacy Policy</a>
      <a :href="getFooterLink('/disclaimer')" class="app-footer__link">Disclaimer</a>
      <a :href="getFooterLink('/cities')" class="app-footer__link">Explore Cities</a>
      <a :href="getFooterLink('/collections')" class="app-footer__link">Collections</a>
    </div>

    <!-- Contact Pill -->
    <div class="app-footer__contact">
      <a :href="`mailto:${contactEmail}`" class="app-footer__contact-link">
        {{ contactEmail }}
      </a>
    </div>

    <!-- Copyright -->
    <div class="app-footer__copyright">
      {{ copyrightText }}
    </div>

    <!-- Toast 提示 -->
    <div class="app-footer__toast" v-if="showToastMessage">
      <div class="app-footer__toast-content">
        Link Copied
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppFooter',
  data () {
    return {
      showToastMessage: false,
      toastTimer: null
    }
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig'
    }),
    contactEmail () {
      return this.domainConfig?.IAMEMAIL || 'CONTACT_EMAIL';
    },
    siteNameText () {
      return this.domainConfig?.siteName || 'SITE_NAME';
    },
    copyrightText () {
      return `Copyright © 2026 ${this.siteNameText}. All Rights Reserved.`;
    }
  },
  methods: {
    getFooterLink (link) {
      const currentQuery = this.$route.query;
      const queryString = Object.keys(currentQuery).length > 0
        ? `?${new URLSearchParams(currentQuery).toString()}`
        : '';

      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}${link}${queryString}`;
      }
      return `${link}${queryString}`;
    },
    showToast () {
      // ... (Keep existing toast logic if needed, though social icons are removed in new design)
    }
  }
}
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.app-footer {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	box-sizing: border-box;
	padding: rem(60) rem(180);
	background: $color-bg-cream;
	border-top: 1px solid rgba(0, 0, 0, 0.1);
	gap: rem(40);
	text-align: center;

	&__brand {
		font-family: $font-family-serif;
		font-weight: 700;
		font-size: rem(32);
		line-height: rem(32);
		text-transform: uppercase;
		color: #000;
	}

	&__links {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: rem(20) rem(40);
	}

	&__link {
		font-family: $font-family-serif;
		font-size: rem(14);
		color: #000;
		text-decoration: underline;
		text-decoration-skip-ink: none;
		cursor: pointer;

		&:hover {
			color: rgba(0, 0, 0, 0.6);
		}
	}

	&__contact {
		background: rgba(0, 0, 0, 0.1);
		border: 1px solid rgba(0, 0, 0, 0.1);
		border-radius: rem(100);
		padding: rem(8) rem(16);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__contact-link {
		font-family: $font-family-serif;
		font-size: rem(14);
		color: #000;
		text-decoration: none;
	}

	&__copyright {
		font-family: $font-family-serif;
		font-size: rem(12);
		color: rgba(0, 0, 0, 0.5);
	}

	&__toast {
		position: fixed;
		bottom: 50%;
		left: 50%;
		transform: translate(-50%, 50%);
		padding: rem(10) rem(20);
		background: rgba(0, 0, 0, 0.7);
		color: #fff;
		border-radius: rem(4);
		z-index: 9999;
		font-size: rem(14);
		max-width: rem(200);
		text-align: center;
	}

	// Mobile specific overrides
	&--mobile {
		padding: rem(60) rem(16);
		gap: rem(32);

		.app-footer__links {
			flex-direction: row;
			gap: rem(20) rem(32);
		}
	}
}
</style>
